import React, { useRef, useEffect, useCallback, useState} from 'react';
import {EFFECTS} from 'constants/arrangement-modes.js';
import InstallationVolume from "components/track/InstallationVolume.js";
import {
    setArrangementPatternSelected,
    setArrangementBottomMode,
} from 'actions/index.js';
import AutomationParameterDropdowns from 'components/automation/AutomationParameterDropdowns.js';
import AutomationToolbar from "components/installation/AutomationToolbar.js";
import Colors from 'components/Colors.js';
import {connect} from 'react-redux';
import {getTrackName} from 'utils/getTrackName.js';

const colors = new Colors();
const DOUBLE_CLICK_TIME = 200;

const TrackSidePanel = ({
    setPatternSelected,
    track,
    isSelectedTrack,
    enabled,
    muted,
    solod,
    setBottomMode
}) => { 
    let lastClick = useRef(0);
    let name = track.presetName || track.getName();
    if (!track.presetName && track.sample) {
        name = track.sample.name;
    }

    let color = colors.getColorForTrack(track);

    let style = {
    };

    if (isSelectedTrack ){
        style.backgroundColor = color;
    }

    const onClick = useCallback((e) => {
        e.stopPropagation();
        track.sequencerEngine.selectTrack(track.trackNumber);

        let now = new Date().getTime();
        if (now - lastClick.current < DOUBLE_CLICK_TIME) {
            setBottomMode(EFFECTS);
        }

        lastClick.current = now;
    }, [track]);

    const onClickMute = useCallback(() => {
        track.mute(!muted);
    }, [muted, track]);

    const onClickSolo = useCallback(() => {
        track.solo(!solod);
    }, [solod, track]);

    const onClickEnable = useCallback(() => {
        track.setIsEnabled(!enabled);
    }, [enabled, track]);

    return (
        <div
          onClick={onClick}
          style={{borderRightColor: color}} className="track-side-panel">
          <div
            style={style}
            className="track-name">
            {name.trim()}
          </div>
          <AutomationParameterDropdowns
            isMix={true}
            sequencerEngine={track.sequencerEngine}
            track={track}/>
          <div className="track-controls">
            <InstallationVolume track={track} sequencerEngine={track.sequencerEngine}/>
            <div
              onClick={onClickMute}
              className={muted ? "muted mute-btn" : "mute-btn"}>{track.trackNumber + 1}</div>
            <div
              onClick={onClickSolo}
              className={solod ? "solod solo-btn" : "solo-btn"}>s</div>
            <div
              onClick={onClickEnable}
              className={enabled ? "enabled enable-btn" : "enable-btn"}></div>
          </div>
        </div>);
}

const mapStateToProps = (state, props) => {
    let isSelectedTrack = state.mix.selectedTrack === props.track.trackNumber; 
    let currentSubSequence = props.track.sequencerEngine.currentSubSequence;
    let track = props.track;
    let _track = track;
    if (track && track.tracks && track.tracks[0]) {
        _track = track.tracks[0].track;
    }
    
    return {
        id: _track.presetName ? _track.presetName :
            _track.sample !== undefined && _track.sample.getId() !== undefined ?
            _track.sample.getId() :
            _track.getName(),
        isSelectedTrack: isSelectedTrack && props.track.subSequence === currentSubSequence,
        solod: props.track.getSolo(),
        muted: props.track.muted,
        enabled: props.track.isEnabled
    };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setPatternSelected: (x) => dispatch(setArrangementPatternSelected(x)),
      setBottomMode: (x) => dispatch(setArrangementBottomMode(x))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TrackSidePanel);
